import { useMemo } from "react";
import { useViewport } from "./useViewport";
export var useResponsiveValue = function(param, minWidthBreakpoints) {
    var mobileAndAbove = param.mobileAndAbove, tabletAndAbove = param.tabletAndAbove, desktopAndAbove = param.desktopAndAbove, xLargeAndAbove = param.xLargeAndAbove, xxLargeDesktop = param.xxLargeDesktop;
    var _useViewport = useViewport(minWidthBreakpoints), isXXLargeDesktop = _useViewport.isXXLargeDesktop, isXLargeAndAbove = _useViewport.isXLargeAndAbove, isDesktopAndAbove = _useViewport.isDesktopAndAbove, isTabletAndAbove = _useViewport.isTabletAndAbove;
    return useMemo(function() {
        if (isXXLargeDesktop) {
            var _ref, _ref1, _ref2;
            return (_ref2 = (_ref1 = (_ref = xxLargeDesktop !== null && xxLargeDesktop !== void 0 ? xxLargeDesktop : xLargeAndAbove) !== null && _ref !== void 0 ? _ref : desktopAndAbove) !== null && _ref1 !== void 0 ? _ref1 : tabletAndAbove) !== null && _ref2 !== void 0 ? _ref2 : mobileAndAbove;
        }
        if (isXLargeAndAbove) {
            var _ref3, _ref4;
            return (_ref4 = (_ref3 = xLargeAndAbove !== null && xLargeAndAbove !== void 0 ? xLargeAndAbove : desktopAndAbove) !== null && _ref3 !== void 0 ? _ref3 : tabletAndAbove) !== null && _ref4 !== void 0 ? _ref4 : mobileAndAbove;
        }
        if (isDesktopAndAbove) {
            var _ref5;
            return (_ref5 = desktopAndAbove !== null && desktopAndAbove !== void 0 ? desktopAndAbove : tabletAndAbove) !== null && _ref5 !== void 0 ? _ref5 : mobileAndAbove;
        }
        if (isTabletAndAbove) {
            return tabletAndAbove !== null && tabletAndAbove !== void 0 ? tabletAndAbove : mobileAndAbove;
        }
        return mobileAndAbove;
    }, [
        desktopAndAbove,
        isDesktopAndAbove,
        isTabletAndAbove,
        isXLargeAndAbove,
        isXXLargeDesktop,
        mobileAndAbove,
        tabletAndAbove,
        xLargeAndAbove,
        xxLargeDesktop
    ]);
};
